/**
 * Avatar — circular initials or agent badge.
 * Ported from design_system/ui_kits/app/_atoms.jsx.
 */

import type { CSSProperties } from "react";

type AvatarProps = {
  initials: string;
  isAgent?: boolean;
  online?: boolean;
  size?: 20 | 24 | 28 | 32 | 40;
  title?: string;
};

export function Avatar({
  initials,
  isAgent = false,
  online,
  size = 24,
  title,
}: AvatarProps) {
  const style: CSSProperties = {
    width: size,
    height: size,
    borderRadius: 9999,
    background: isAgent ? "var(--accent-orange)" : "var(--surface-2)",
    color: isAgent ? "#fff" : "var(--ink)",
    border: isAgent ? "none" : "1px solid var(--hairline)",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    fontFamily: "var(--font-mono)",
    fontSize: size <= 24 ? 10 : 11,
    fontWeight: 500,
    position: "relative",
    flexShrink: 0,
  };
  return (
    <span style={style} title={title ?? initials} aria-label={title ?? initials}>
      {initials.slice(0, 2).toUpperCase()}
      {online !== undefined && (
        <span
          aria-hidden="true"
          style={{
            position: "absolute",
            right: -1,
            bottom: -1,
            width: 8,
            height: 8,
            borderRadius: 9999,
            background: online ? "var(--accent-green)" : "var(--mute-soft)",
            border: "1.5px solid var(--canvas)",
          }}
        />
      )}
    </span>
  );
}
